import Header from "@/components/Header";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Values from "@/components/Values";
import News from "@/components/News";
import Products from "@/components/Products";
import Accessories from "@/components/Accessories";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import SocialMedia from "@/components/SocialMedia";

const Index = () => {
  return (
    <>
      <a
        href="#drakter"
        className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[100] focus:bg-primary focus:text-primary-foreground focus:px-4 focus:py-2 focus:rounded"
      >
        Hopp til hovedinnhold
      </a>
      <main className="overflow-hidden" role="main">
        <Header />
        <Hero />
        <Products />
        <News />
        <Accessories />
        <Values />
        <About />
        <SocialMedia />
        <Contact />
        <Footer />
      </main>
    </>
  );
};

export default Index;
